export default {
  template: `
    <router></router>
  `,
};
